import React from 'react'

interface NeutralChatIconProps {
  className?: string
  style?: React.CSSProperties
}

// Neutral, brand-free chat icon (same speech-bubble glyph used by the
// landing page demo chatbot). Available to Growth+ plans via iconStyle.
export const NeutralChatIcon: React.FC<NeutralChatIconProps> = ({ className, style }) => {
  return (
    <span
      className={className}
      style={{ ...style, display: 'inline-block', lineHeight: 0 }}
    >
      <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
      </svg>
    </span>
  )
}
